import {Injectable, Injector} from '@angular/core';
import {CanActivate} from '@angular/router';
import AuthDataProvider from "./dataProviders/authDataProvider.service";
import * as jssha from 'jssha';
import {Observable} from "rxjs/Rx";
import IUser from "../interfaces/IUser";
import CypherService from "./cypher.service";
import {Router} from '@angular/router';
import * as _ from 'lodash';

@Injectable()
class AuthService implements CanActivate {
    constructor(private authDataProvider: AuthDataProvider,
                private cypherService: CypherService,
                private injector: Injector) {
        this.user = _.cloneDeep(this.emptyUser);
    }

    public user: IUser;
    private emptyUser: IUser = {
        name: '',
        passwordHash: '',
        e_mail: '',
        id: 0,
        is_active: 0,
        is_admin: 0,
        users_app_id: 0
    }

    /**
     * This method checks on a server if a user is active and exists in case
     * he was logged in locally. Which means if there is an entry in localStorage and we
     * want to confirm if this user really exists and is active at the moment.
     *
     * It resolves for all cases intentionally, because in case the user is not active or he does not exist
     * localStorage entry is cleared and canActive verification takes over which will fail if no entry in localStorage.
     *
     * @returns {Promise<T>}
     */
    public isUserActive = (): Promise<null> => {
        return new Promise((resolve) => {
            if (!this.isLocalLoggedIn()) {
                resolve();
            } else {
                this.authDataProvider.login({
                    name: this.user.name,
                    passwordHash: this.user.passwordHash
                }).subscribe((user: IUser) => {
                    if (user.is_active !== 1) {
                        localStorage.removeItem('user');
                    }
                    resolve();
                }, () => {
                    localStorage.removeItem('user');
                    resolve();
                })
            }
        })
    }

    /**
     *
     * Check if user is logged in or not based on local storage
     *
     * @returns {boolean}
     */
    public isLocalLoggedIn(): boolean {
        try {
            this.user = JSON.parse(this.cypherService.decrypt(localStorage.getItem('user')));
            return true;
        } catch (error) {
            console.warn("Unable to parse user data -> logout");
            return false;
        }
    }

    public canActivate(): boolean {
        const isLoggedIn: boolean = this.isLocalLoggedIn();
        if (!isLoggedIn) {
            this.injector.get(Router).navigate(['/login']);
        }
        return isLoggedIn;
    }

    logout(clearUser = true) {
        if (clearUser)
            this.user = this.emptyUser;
        localStorage.removeItem('user');
        this.injector.get(Router).navigate(['/login']);
    }

    loginByHash(user: IUser, passwordHash: string): Observable<any> {
        return this.authDataProvider.login({
            name: user.name,
            passwordHash: passwordHash
        })
            .do((responseUser: IUser) => {
                if (responseUser.is_active !== 1) {
                    throw {
                        inactive: true
                    };
                }
                this.user = responseUser;
                this.user.passwordHash = passwordHash;
                localStorage.setItem('user', this.cypherService.encrypt(JSON.stringify(responseUser)));
            })
    }

    login(user: IUser, password: string): Observable<any> {
        this.authDataProvider.preventDefaultError = true;
        let sha = new jssha("SHA-1", "TEXT");
        sha.update(password);
        user.passwordHash = sha.getHash("HEX");
        return this.loginByHash(user, user.passwordHash);
    }

}

export default AuthService;






// WEBPACK FOOTER //
// ./src/app/services/auth.service.ts